import React,{useState} from 'react';
import {useForm} from 'react-hook-form'
import {API} from '../../Services/axios'
import {URLS} from '../../Services/Urls'
import {toast} from 'react-toastify'
import { setUserDetails } from '../../Components/Utils/Functions';
import { useDispatch } from 'react-redux';
import {loginSuccess} from '../../Redux/Store/Slices/Auth'
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { RiLockFill } from 'react-icons/ri';
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import './login.css'
import { IoMdMail } from "react-icons/io";
import logo from '../../Assets/Images/Bloc-Logo.png'
import { FaEyeSlash } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import Loading from './Loading';







const Login = () => {

  const [loading, setLoading] = useState(false)
  let [searchParams, setSearchParams] = useSearchParams();
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({});
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onSubmit = (data) => {
    setLoading(true)
    console.log('Form Data:', data);
    API.post(URLS.AUTHS.LOGIN, data)
      .then((resp) => {
        const userId = resp.data.public_id;
        localStorage.setItem('userId', userId);
        console.log('resp.data: ', resp.data);
        const redirect = window.localStorage.getItem("redirect");
        let usrData = resp.data.jwt_tokens;
        usrData.access_token = usrData.access;
        usrData.refresh_token = usrData.refresh;
        usrData.user = resp.data.user;
        setUserDetails(usrData);
        dispatch(loginSuccess(usrData));
  
        // Store the access token in local storage
        navigate(searchParams.get("redirect") ?? redirect ?? "/");
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.detail ?? "Login Error");
        console.log('Erreur de connexion')
      });
      // navigate('/');
  };
 

  return (
    <div>
      <div className="container-fluid bg-white overflow-hidden ">
        <div className='row h-100 w-100 '>
          <div className="col-lg-5 col-md-6 col-sm-4 col-12">
            <div className='bg-image h-100'>
              <div className="p-4 text-white">
                <img src={logo} alt="logo" className="img-fluid" />
              </div>

            </div>
          </div>
          <div className='col-lg-7 col-md-6 col-sm-8 col-12 bg-white'>
            <div className="row h-100">
              <div className="col-md-2"></div>
              <div className="col-md-8">
                <div className='h-100 d-flex w-100'>
                  <div className="py-4 row m-auto w-100 ">
                    <div className=" m-auto ">

                      <div className='col-md-10 col-12 col-sm-10 m-auto mt-4 text-center'>
                        <div className="">
                          <h2 className='login-text'>Login</h2>
                          <p className='login-p-text'>Please fill your information below</p>
                        </div>
                        <div className=''>
                        <form  onSubmit={handleSubmit(onSubmit)}>
                          <div className="input-container w-100 mb-3 col-md-12">
                            <IoMdMail className="icon input-color-icon" />
                            <input 
                              type="email" 
                              id='email' 
                              placeholder="E-mail" 
                              className="input w-100 input-color-text rounded"  
                              required =''
                              {...register("email", {
                                required: "text Form Field Required",
                                validate: {
                                  maxLength: (v) =>
                                    v.length <= 50 || "textAtMost",
                                  matchPattern: (v) =>
                                    /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                                      v
                                    ) || "text Valid Email",
                                },
                              })}
                        
                            />
                          </div>
                          <div className="input-container w-100 mb-3 ">
                            <RiLockFill  className="icon input-color-icon" />
                            <input 
                              type={showPassword ? "text" : "password"}
                              {...register("password")} 
                              id='password' 
                              placeholder="Password" 
                              className="input w-100 input-color-text rounded"  
                              required=''
                          
                            />
                            <div
                              className="eye-icon fs-4"
                              onClick={togglePasswordVisibility}
                            >
                              {showPassword ? <FaEye/> : <FaEyeSlash/>}
                            </div>
                          </div>

                          <div className='login-button login-button-form col-md-12' > 
                          <div>
                            <button
                              type="submit"
                              className="btn w-100 login-button-form-color"
                              disabled={loading}
                            >
                              {loading ? (
                                <>
                                  Loading... <span className="ms-4 fs-4"></span>
                                </>
                              ) : (
                                <>
                                  Connexion <span className="ms-4 fs-4"><MdOutlineKeyboardArrowRight /></span>
                                </>
                              )}
                            </button>
                            {loading && <Loading />}
                          </div> 
                          </div>
                        </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-2"></div>
            </div>
          </div>
        </div>
      </div>
    </div>


)
}

export default Login